import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';
import About from '../containers/about';

type AboutPageProps = {};

const AboutPage: React.FunctionComponent<AboutPageProps> = (props) => {
  return (
    <Layout>
      <SEO
        title="about me"
        description="though i may not fully understand it, i am deeply drawn to the intricate patterns and vibrant hues, the balance between order and chaos. however, i must remind myself that i am but a simple mortal. but even as a primitive man, the beauty and complexity of these shapes and colors never cease to amaze me."
      />

      <About />
    </Layout>
  );
};

export default AboutPage;
